export const marketingAttributionReduxConstants = {
  DASHBOARD_MARKETING_ATTRIBUTION: "DASHBOARD_MARKETING_ATTRIBUTION",
  GET_MARKETING_ATTRIBUTION_PAGINATED_DATA:
    "GET_MARKETING_ATTRIBUTION_PAGINATED_DATA",
  GET_MARKETING_ATTRIBUTION_GRAPH_DATA: "GET_MARKETING_ATTRIBUTION_GRAPH_DATA",
  GET_MARKETING_ATTRIBUTION_REPORT_BODY:
    "GET_MARKETING_ATTRIBUTION_REPORT_BODY",
};

export const chartStyleOptions = {
  legend: { position: "none" },
  colors: ["#027b68", "#0b0f36"],
  backgroundColor: "#fff",
  bar: { width: "20%" },
  annotations: {
    alwaysOutside: true,
    textStyle: {
      fontSize: 10,
      fontWeight: 800,
      color: "#000",
      auraColor: "#fff",
    },
  },
  hAxis: {
    title: "Days After Marketing",
    titleTextStyle: {
      color: "#444",
      fontName: "montserrat",
      fontSize: 13,
      italic: false,
    },
    viewWindow: {
      min: 0,
    },
    format: "0",
  },
  vAxis: {
    title: "Number of Orders",
    titleTextStyle: {
      color: "#444",
      fontName: "montserrat",
      fontSize: 13,
      italic: false,
    },
    format: "0",
  },
};

export const apexChartStyleOptions = {
  chart: {
    type: "bar",
    height: 350,
    stacked: true,
    toolbar: {
      show: false,
    },
    selection: { enabled: false },
    zoom: { enabled: false },
  },
  grid: {
    show: true,
    strokeDashArray: 0,
    position: "back",
    xaxis: {
      lines: {
        show: true,
      },
    },
    yaxis: {
      lines: {
        show: true,
      },
    },
    borderColor: "#ebebeb",
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
  },
  legend: {
    show: false,
  },
  dataLabels: {
    enabled: false,
  },
  responsive: [
    {
      breakpoint: 480,
      options: {},
    },
  ],
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "40%",
      dataLabels: {
        position: "top",
        hideOverflowingLabels: true,
        orientation: "vertical",
        total: {
          enabled: true,
          style: {
            fontSize: "12px",
            fontWeight: 700,
          },
        },
      },
    },
  },
  xaxis: {
    tickAmount: "dataPoints",
    tickPlacement: "on",
    title: {
      offsetY: 3,
      text: "Days After Marketing",
      style: {
        fontWeight: 500,
        fontSize: 13,
      },
    },
  },
  yaxis: {
    title: {
      offsetX: -5,
      text: "Number of Orders",
      rotate: -90,
      style: {
        fontWeight: 500,
        fontSize: 13,
      },
    },
  },
  fill: {
    opacity: 1,
  },
  tooltip: {
    enabled: true,
    intersect: false,
  },
};
export const reportGraphHeaders = {
  DAYS_AFTER_MARKETING: "Days After Marketing",
  TOTAL_ORDERS: "Total Orders",
};

export const MARKETING_ATTRIBUTION_LABELS = {
  SELECT_GROUP: "Select Group",
  SELECT_STORE: "Select Store",
  NO_DATA_FOUND: "No Data Found",
  DATE_RANGE_PREFIX: "Date Range:",
};

export const messageType = {
  3: "Email",
  4: "SMS",
};

export const eventDateConstant = {
  EVENT_DATE_REPLACEMENT: "<li>Event Date: 1/1/0001 12:00:00 AM</li>",
};

export const TASK_9 = "task9";
export const DELIVERY_9 = "delivery9";
